<template>
	<div class="case">案例</div>
</template>

<script>
	import ApiSetting from '../../assets/js/interface'
	import Panel from '../public/panel.vue'
	import backTop from '../public/backTop.vue'

	export default {
		name: 'case',
		props: [],
		data() {
			return {
			};
		},
		components: {
			Panel,
			backTop,
		},
		mounted() {
			//动画初使化
			new this.$WOW.WOW({live: false}).init();
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	@import '../../assets/css/common';
	.case{
		
	}
</style>



// WEBPACK FOOTER //
// src/components/case/Case.vue